import { isValidElement, type ReactNode } from "react";
import type { CardProps } from "components/src/components/Card/types";
import type { MarketTemplateProps } from "../types";
import isEmpty from "lodash-es/isEmpty";
import { addProps } from "shared/src/utils/addProps";
import type { DetailBgColorType } from "components/src/components/Details/types";
import { Details } from "components/src/components/Details/Details";

export type MarketTemplatePreparedHeader = {
  hasHeader: boolean;
  computedHeader: Partial<CardProps>;
  _hasSGP: boolean;
  collapsible: boolean;
  isReactNode: boolean;
  component?: ReactNode;
};


export function prepareMarketTemplateHeader({
  hasSGP,
  header,
  isOddsBoost,
  boostLogoType = "full",
  onHeaderClick,
  initiallyOpen,
  animation,
}) {
  const hasHeader = !!header && typeof header === "object" && !isEmpty(header);
  const isReactNode = isValidElement(header);
  const headerComponent = isReactNode
    ? addProps(header, {
        onClick: onHeaderClick,
      })
    : null;

  const _headerDetails = header?.headerDetails ?? [];

  typeof hasSGP === "boolean" && hasSGP && _headerDetails.push({ leftIcon: { size: "lg", name: "ui_sgp", color: "fg-primary-strong" } });

  typeof header?.trailingIcon === "object" &&
    "name" in header?.trailingIcon &&
    _headerDetails.unshift({
      leftIcon: { size: "lg", ...header?.trailingIcon },
    });

  let _leadingIcon = header?.leadingIcon;
  const isFullBoost = isOddsBoost && boostLogoType === "full";

  if (isOddsBoost && !header?.leadingIcon) {
    _leadingIcon = <Details list={[{ leftIcon: { name: isFullBoost ? "brand_boost_logo" : "icon_ui_boost", size: isFullBoost ? "3xl" : "sm", color: "fg-global-black" }, noMargin: true, classes: "cui-py-1 cui-px-2 cui-mr-1", bgColor: "highlight-five" as DetailBgColorType }]} />
  }

  const _header: Partial<MarketTemplateProps["header"]> & {
    headerDetails?: {}[];
  } = !!header
    ? {
        ...header,
        headerDetails: _headerDetails,
        headerConfig: {
          paddingClasses: header?.paddingClasses ?? "cui-py-xs",
          leadingIcon: _leadingIcon,
          trailingIcon: header?.trailingIcon,
          showActiveAndHoverState: header?.showActiveAndHoverState,
          animation,
        },
        initiallyOpen,
      }
    : {};

  const _collapsible =
    hasHeader && typeof header?.collapsible === "boolean"
      ? header?.collapsible
      : true;
  return {
    computedHeader: !isReactNode ? (_header as Partial<CardProps>) : undefined,
    collapsible: _collapsible,
    hasHeader,
    isReactNode,
    component: isReactNode ? headerComponent : null,
  };
}
